  // For anyone editing this, I tried to document what I could but honestly, it is a lot of trial and error
 // Have fun. There some styling stuff in theme.liquid...check that out if you need to adjust
// Last edited by Geoff 'starfox221' Stevens on 4/8/2025

document.addEventListener('algolia.hooks.initialize', function () {

algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function(options) {
  const widgets = options.facets.widgets.map(widget => {
    if (widget.name !== 'refinementList') {
      return widget;
    }

    return {
      ...widget,
      params: {
        ...widget.params,
        limit: 10,
        showMore: true,
        templates: {
          ...widget.params.templates,
          item: `
            <label class="algolia-facet-item">
              <input type="checkbox" value="{{value}}" {{#isRefined}}checked{{/isRefined}} />
              <span>{{label}} ({{count}})</span>
            </label>
          `
        }
      }
    };
  });

  return {
    ...options,
    facets: {
      ...options.facets,
      widgets
    }
  };
});




// Main Template Hook
algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
  return html`
    <div class="ais-page">
      <!-- 🔹 Custom dynamic title element -->
      test
      <h1 class="ais-h2">
        <span id="search-query-output">${algoliaShopify.instantsearch.search.helper.state.query}</span>
      </h1>

      <div class="ais-input">
        <div class="ais-search-box-container"></div>
        <div class="ais-input-button">
          <div class="ais-clear-input-icon"></div>
        </div>
      </div>

      <div class="ais-facets-button">
        ${algoliaShopify.translations.showFilters}
      </div>

      <div class="ais-facets">
        <div class="ais-clear-refinements-container"></div>
        <div class="ais-current-refined-values-container"></div>
        ${data.facets.map(
          facet =>
            html`
              <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
                <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
                  ${facet.title}
                </label>
                <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
              </div>
            `
        )}
      </div>

      <div class="ais-block">
        <div class="ais-search-header">
          <div class="ais-stats-container"></div>
          <div class="ais-change-display">
            <span class="ais-change-display-block ais-change-display-selected">
              <i class="fa fa-th-large"></i>
            </span>
            <span class="ais-change-display-list">
              <i class="fa fa-th-list"></i>
            </span>
          </div>
          <div class="ais-sort">
            ${data.multipleSortOrders
              ? html`
                  ${algoliaShopify.translations.sortBy}
                  <span class="ais-sort-orders-container"></span>
                `
              : html`
                  ${algoliaShopify.translations.sortBy}
                  ${algoliaShopify.translations.relevance}
                `}
          </div>
        </div>
        <div class="ais-hits-container ais-results-as-block"></div>
      </div>

      <div class="ais-pagination-container"></div>

      <!-- 🔹 Dynamic title update script -->
      <script>
        if (window.algoliaShopify && window.algoliaShopify.instantsearch) {
          const searchInstance = algoliaShopify.instantsearch;

          searchInstance.on('render', () => {
            const query = searchInstance.helper.state.query;
            const outputElement = document.getElementById('search-query-output');

            // Get category name from meta tag or DOM element
            const metaCategory = document.querySelector('meta[name="category"]')?.content;
            const domCategory = document.getElementById('collection-title')?.textContent?.trim();
            const fallbackCategory = metaCategory || domCategory || 'All Products';

            if (outputElement) {
              outputElement.textContent = query
                ? 'Search Results for: "' + query + '"'
                : 'Shop: ' + fallbackCategory;
            }
          });
        } else {
          console.error('Algolia instance not found.');
        }
      </script>
    </div>
  `;
});






  


 algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
  <img
  class="ais-hit--picture"
  src="${hitImage.src}"
  srcset="${hitImage.srcset}"
  sizes="${hitImage.sizes}"
  alt="${hit.title} - ${hit.variant_title}"
  style="width: 60%; max-width: 100%; height: auto; object-fit: contain; flex-shrink: 0;"
/>

        <div class="ais-hit--details">
<p class="ais-hit--title" style="text-transform: uppercase; margin: 0; text-align: center; padding-top: 65px!important;">
  <a
    data-algolia-index="${hit.index}"
    data-algolia-position="${hit.productPosition}"
    data-algolia-queryid="${hit.queryID}"
    data-algolia-objectid="${hit.objectID}"
    href="${algoliaShopify.helpers.instantsearchLink(hit)}"
    title="${algoliaShopify.helpers.fullTitle(
      hit.title,
      hit._distinct,
      hit.variant_title
    )}"
    style="
      display: -webkit-box;
      -webkit-box-orient: vertical;
      
      overflow: hidden;
      text-overflow: clip;
      max-width: 100%;
      font-size: 13px!important;
      white-space: normal;
      word-break: break-word;
      text-decoration: none;
      text-align: center;
      font-weight: bold;
      color: #FFF!important;
    "
  >
    ${components.Highlight({ attribute: 'title', hit })}
    ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
  </a>
</p>




     <p
  class="ais-hit--subtitle"
  style="color: white; padding-top: 5px; font-size: 14px;"
  title="${hit.product_type}"
>
 ${hit.body_html_safe &&
  html`
    <style>
      .only-in-list-view {
        display: none;
        color: white;
        padding-top: 5px;
        font-size: 14px;
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
        line-height: 1.4;
      }
  .ais-page .ais-results-as-list .ais-hit--details {
    margin-left: 210px;
}
      .ais-results-as-list .only-in-list-view {
        display: block;
      }
    </style>
    <span class="algolia-description-truncated only-in-list-view">
      ${hit.body_html_safe
        .replace(/(<([^>]+)>)/gi, '') // Strip HTML
        .split(/\s+/)
        .slice(0, 35)
        .join(' ')
        .trim()}...
    </span>
  `}

</p>
      <p class="ais-hit--price" style="text-align: center;">
  <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
  ${!hit._distinct &&
    html`
      <span class="ais-hit--price-striked">
        <span>
          ${algoliaShopify.helpers.displayStrikedPrice(
            hit.price,
            hit.compare_at_price
          )}
        </span>
      </span>
    `}
  ${!hit._distinct &&
    html`
      <span class="ais-hit--price-discount">
        ${algoliaShopify.helpers.displayDiscount(
          hit.price,
          hit.compare_at_price,
          hit.price_ratio
        )}
      </span>
    `}
</p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display:none;">
            ${hit.body_html_safe &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'body_html_safe', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display:none;">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });
});
